import { Text, View } from '@react-pdf/renderer';
import { type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';

interface FieldItemProps {
  label: string;
  value?: string;
}

export const FieldItem = ({ label, value }: FieldItemProps): ReactElement => (
  <View style={PDF_STYLES.field}>
    <Text style={PDF_STYLES.fieldLabel}>{label}</Text>
    <Text style={PDF_STYLES.fieldValue}>{value ?? ''}</Text>
  </View>
);
